export default __webpack_public_path__ + "static/media/Set1_Board2.64c4da88.png";